import React__default from 'react';
import { Text } from '@grandvisionhq/elements';
import { useSelector } from '@grandvisionhq/state';
import { getSelectedShippingMethod } from '../../../StepShipping/selectors.js';
import { useCheckoutSettings } from '../../../context/CheckoutSettings/context.js';
import { isPickupStore } from '../../../utils/shipping-method.js';
import { TitleWithIcon } from '../../../components/TitleWithIcon/TitleWithIcon.js';

const ServiceStoreHeading = ({ hideIcon =false , showAsteriksSignInSubTitle =false , title , subtitle  })=>{
    const { features  } = useCheckoutSettings();
    const selectedShippingMethod = useSelector(getSelectedShippingMethod);
    const isPickupStoreSelected = isPickupStore(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method);
    if (!(features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) || isPickupStoreSelected) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(TitleWithIcon, {
        icon: "store",
        hideIcon: hideIcon,
        hideAsteriskSign: showAsteriksSignInSubTitle,
        label: title
    }), /*#__PURE__*/ React__default.createElement(Text, {
        component: "p",
        className: "checkout-step__subtitle"
    }, subtitle, showAsteriksSignInSubTitle && /*#__PURE__*/ React__default.createElement("span", {
        className: "service-store__asterisk"
    }, "*")));
};

export { ServiceStoreHeading, ServiceStoreHeading as default };
//# sourceMappingURL=ServiceStoreHeading.js.map
